// MouseTracker.tsx

import React, { useState, useEffect } from 'react';
import './MouseTracker.css';

const MouseTracker: React.FC = () => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (event: MouseEvent) => {
        setMousePosition({ x: event.clientX, y: event.clientY });
    };

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove);
        return () => document.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div className="mouse-tracker" style={{ left: mousePosition.x, top: mousePosition.y }}>
            <div className="glow-effect"></div>
        </div>
    );
};

export default MouseTracker;
